import gql from 'graphql-tag';

export const FRAGMENT_DOCUMENT_LINK = gql`
  fragment DocumentLink on DocumentLink {
    shareDocumentId
  }
`;

export const FRAGMENT_DOCUMENT_VIEW = gql`
  fragment DocumentView on DocumentView {
    id
    name
    editorContent
    editable
  }
`;
